import React, { forwardRef, Ref } from 'react';

import HorizontalMovieListItemSkeleton from '@/app/[locale]/(default-layout)/_components/skeletons/HorizontalMovieListItemSkeleton';

type HorizontalMovieListSkeletonProps = {
    items?: number;
};

function HorizontalMovieListSkeleton(
    props: HorizontalMovieListSkeletonProps,
    ref: Ref<HTMLDivElement>
): React.JSX.Element {
    return (
        <div
            className="flex flex-col lg:flex-row space-x-0 lg:space-x-72 space-y-24 lg:space-y-0 items-start"
            ref={ref}>
            <div className="relative w-full">
                <div className="relative flex flex-row overflow-x-auto space-x-16 no-scrollbar">
                    {[...Array(Math.max(0, props.items ?? 3))].map((_, index) => (
                        <HorizontalMovieListItemSkeleton key={`HorizontalMovieListItemSkeleton${index}`} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default forwardRef(HorizontalMovieListSkeleton);
